import React from 'react';
import { config } from '../../config';

const AddressInputAU = React.lazy(() => import('./address-input-au'));
const AddressInputUK = React.lazy(() => import('./address-input-uk'));
const AddressInput =
  config.country === 'Australia' ? AddressInputAU : AddressInputUK;

export default AddressInput;
